import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Navbar from '../components/Navbar';
import PostCard from '../components/PostCard';
import axios from 'axios';
import PostCardSkeleton from '../components/PostCardSkeleton';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Home = () => {
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const hasLoadedRef = useRef(false);
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (hasLoadedRef.current) return;
    hasLoadedRef.current = true;

    if (user && (user.role === 'admin' || user.role === 'super_admin')) {
      navigate(user.role === 'super_admin' ? '/super-admin' : '/admin');
    } else {
      loadPost();
    }
  }, [user, navigate]);

  const loadPost = async () => {
    setLoading(true);
    const start = Date.now();
    try {
      const res = await axios.get(`${API}/posts/feed`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.data.post) {
        setPost(res.data.post);
      } else {
        setPost(null);
      }
    } catch (err) {
      console.error('Error loading post:', err);
    } finally {
      const elapsed = Date.now() - start;
      setTimeout(() => setLoading(false), Math.max(500 - elapsed, 0)); // Ensure at least 500ms loading time for better UX
    }
  };

  const handleSkip = async () => {
    if (post) {
      try {
        await axios.post(`${API}/posts/${post.id}/skip`, {}, {
          headers: { Authorization: `Bearer ${token}` }
        });
        loadPost();
      } catch (err) {
        console.error('Error skipping post:', err);
      }
    }
  };

  const handleVoteComplete = () => {
    if (post) {
      handleSkip();
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 transition-colors">
      <Navbar />
      
      <div className="pt-24 pb-12 px-4 sm:px-6 lg:px-8" data-testid="home-page">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8 page-header-center">
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">Cast Your Verdict</h1>
            <p className="text-gray-600 dark:text-slate-400">Judge real life situation anonymously</p>
          </div>

          {loading ? (
            <PostCardSkeleton />
          ) : post ? (
            <PostCard
              post={post}
              onSkip={handleSkip}
              onVoteComplete={handleVoteComplete}
            />
          ) : (
            <div className="text-center py-20">
              <p className="text-gray-600 dark:text-slate-400 text-lg">
                No more posts to show
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Home;
